import { Component, inject, signal, ViewChild, computed } from '@angular/core';
import { DialogComponent } from 'src/app/_shared/components/dialog/dialog.component';
import { ShareType, SocialButtonConfig, shareTypeToConfig } from 'src/app/models/social';
import { ApiService } from 'src/app/services/api.service';
import { ConfigService } from 'src/app/services/config.service';
import { UserService } from 'src/app/services/user.service';
import { RecommendationsDialogInfo } from 'src/app/state/user-config/models/user-config.response';
import { UserConfigFacade } from 'src/app/state/user-config/user-config.facade';

@Component({
  selector: 'app-recommend-platform-dialog',
  templateUrl: './recommend-platform-dialog.component.html',
  styleUrls: ['./recommend-platform-dialog.component.scss'],
})
export class RecommendPlatformDialog {

  private readonly configService = inject(ConfigService);
  private readonly apiService = inject(ApiService);
  private readonly userService = inject(UserService);
  private readonly userConfigFacade = inject(UserConfigFacade);

  readonly isRecommendButtonPressed = signal<boolean>(false);
  readonly recommendationDialogInfo = signal<RecommendationsDialogInfo>(this.userConfigFacade.recommendationsDialogInfo);

  readonly configs = computed<SocialButtonConfig[]>(() => {
    let configItems = [];
    this.configService.shareIcons.forEach((type) => {
      configItems.push(shareTypeToConfig.get(type))
    })

    return configItems;
  });

  @ViewChild('dialog') dialog!: DialogComponent;

  close(remindLater: boolean) {
    if (!remindLater) {
      this.apiService.saveUserRecommendationDialogLastAction(this.userService.getUserId(), 'reject').subscribe();
    }
    this.dialog.closeDialog();
  }

  recommendPlatform() {
    this.apiService.saveUserRecommendationDialogLastAction(this.userService.getUserId(), 'accept').subscribe();
    this.isRecommendButtonPressed.set(true);
  }
}
